function normalizeText(text) {
  var value = (text || '').toLowerCase().trim();

  if (typeof value.normalize === 'function') {
    return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  return value
    .replace(/[áàâãä]/g, 'a')
    .replace(/[éèêë]/g, 'e')
    .replace(/[íìîï]/g, 'i')
    .replace(/[óòôõö]/g, 'o')
    .replace(/[úùûü]/g, 'u')
    .replace(/ç/g, 'c');
}

function getFilterPropertyByHeading(text) {
  var normalized = normalizeText(text);

  if (normalized.indexOf('tamanho') !== -1) {
    return 'property2_values';
  }

  if (normalized.indexOf('ambiente') !== -1) {
    return 'property3_values';
  }

  return '';
}

function buildSearchUrl(value, property) {
  var cleanValue = (value || '').replace(/^[-\s•]+/, '').trim();
  var encoded = encodeURIComponent(cleanValue);
  return '/busca?q=' + encoded + '&' + property + '[]=' + encoded;
}

function convertListItemsToLinks(listElement, property) {
  var items = listElement.querySelectorAll('li');

  items.forEach(function (item) {
    if (item.querySelector('a.description-filter-link')) {
      return;
    }

    var value = (item.textContent || '').trim();
    if (!value) {
      return;
    }

    var link = document.createElement('a');
    link.className = 'description-filter-link';
    link.href = buildSearchUrl(value, property);
    link.textContent = value;
    link.setAttribute('aria-label', 'Filtrar por ' + value);

    item.textContent = '';
    item.appendChild(link);
  });
}

function convertParagraphToLinks(paragraph, property) {
  if (paragraph.querySelector('a.description-filter-link')) {
    return;
  }

  var text = (paragraph.textContent || '').trim();
  if (!text) {
    return;
  }

  var parts = text
    .split(/[,;|]/)
    .map(function (part) {
      return part.trim();
    })
    .filter(Boolean);

  if (parts.length < 2) {
    return;
  }

  paragraph.textContent = '';

  parts.forEach(function (part, index) {
    var link = document.createElement('a');
    link.className = 'description-filter-link';
    link.href = buildSearchUrl(part, property);
    link.textContent = part;
    link.setAttribute('aria-label', 'Filtrar por ' + part);
    paragraph.appendChild(link);

    if (index < parts.length - 1) {
      paragraph.appendChild(document.createTextNode(' | '));
    }
  });
}

export default function setAlternatedBannersFilters() {
  var blocks = document.querySelectorAll('.side-by-side .texts-inner');

  if (!blocks.length) {
    return;
  }

  blocks.forEach(function (block) {
    if (block.dataset.filtersLinked === 'true') {
      return;
    }

    var children = Array.prototype.slice.call(block.children || []);

    children.forEach(function (child, index) {
      var activeProperty = getFilterPropertyByHeading(child.textContent);
      if (!activeProperty) {
        return;
      }

      for (var i = index + 1; i < children.length; i += 1) {
        var next = children[i];
        var nextProperty = getFilterPropertyByHeading(next.textContent);

        if (nextProperty) {
          break;
        }

        if (next.matches('ul, ol')) {
          convertListItemsToLinks(next, activeProperty);
          continue;
        }

        if (next.querySelector('ul, ol')) {
          next.querySelectorAll('ul, ol').forEach(function (listElement) {
            convertListItemsToLinks(listElement, activeProperty);
          });
          continue;
        }

        if (next.matches('p.description')) {
          convertParagraphToLinks(next, activeProperty);
        }
      }
    });

    block.dataset.filtersLinked = 'true';
  });
}
